import { Paper, Typography } from "@mui/material"

const SpecTile = ({ label, value }) => (
    <Paper
        variant="outlined"
        sx={{
            p: 2,
            borderRadius: 2,
            height: "100%",
            borderColor: "rgba(0, 4, 53, 0.08)",
            bgcolor: "#fff",
        }}
    >
        <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
            {label}
        </Typography>
        <Typography variant="body1" fontWeight={700} color="#000435" lineHeight={1.3}>
            {value}
        </Typography>
    </Paper>
)

export default SpecTile
